import React from 'react'
import { Image, Row, Col, Container } from 'react-bootstrap';
import Slider from 'react-slick';
import GoogleRatingImg from '../.././../Assets/images/shopify-img/google-rating.png';
import GoogleReviewImg from '../.././../Assets/images/shopify-img/google-review.png';
import GoogleBagImg from '../.././../Assets/images/shopify-img/shopify-bag-img.png';
import { useHistory } from 'react-router-dom';
import { Rating } from '@material-ui/lab';
const HappyCustomers = () => {

  const history = useHistory();
  const settingsReview = {
    dots: false,
    infinite: true,
    arrows:false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,  
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const happyCustomers = [
    {
      id: 1,
      name: "Jane Doe",
      company: "Elegant Apparel",
      testimonial: "They transformed our online store. Sales have increased and the site looks amazing!",
      image: "path/to/customer1.jpg"
    },
    {
      id: 2,
      name: "Michael Smith",
      company: "TechGear Hub",
      testimonial: "Fantastic service and support throughout the development process. Highly recommend!",
      image: "path/to/customer2.jpg"
    },
    {
      id: 3,
      name: "Ava Johnson",
      company: "EcoBliss",
      testimonial: "Their attention to detail and Shopify expertise made all the difference for our brand.",
      image: "path/to/customer3.jpg"
    },
    {
      id: 4,
      name: "Liam Brown",
      company: "Pet Haven Co.",
      testimonial: "Superb communication, great design, and an increase in customer satisfaction!",
      image: "path/to/customer4.jpg"
    }
  ];
  const googleReviews = [
    {
      name: "Romil Shah",
      reviews: 5,
      photos: 0,
      time: "6 days ago",
      comment: "Working with this web development team has been a great experience. Their quick response times and clear communication make everything run smoothly. What sets them apart is the strength and diversity of their team — they have true experts."
    },
    {
      name: "L. Edwards",
      reviews: 12,
      photos: 4,
      time: "a week ago",
      comment: "We’ve had a fantastic experience working with this website service. From the start, they’ve been incredibly attentive to our needs and quick to respond to any requests. Our representative, Simoli, has been outstanding—creative, efficient."
    },
    {
      name: "Sydney Sebata",
      reviews: 2,
      photos: 0,
      time: "a week ago",
      comment: "Now I can commend you with a well-deserved 6 Star Rating for your services. You are able to adapt to challenges and deliver on great work even with different language barriers. I am humbled to work with you Ms Simoli and Team.😇"
    },
  
    {
      name: "Swales Diamonds",
      reviews: 2,
      photos: 0,
      time: "2 weeks ago",
      comment: "Great efficient web build service. Zahid Zaidi is also great at SEO work and keyword recommendations. Excellent blog writing."
    },
 
 
  ];


  return (
    <div className='bw_happy_customers_section'>
      <Container className='bw_custome_footer_container '>
        <Row>
          <Col sm={12} md={4} lg={4}>
            <div className='bw_happy_customers_section_left'>
              <h2 className=''><Image src={GoogleBagImg} alt='shopify Happy customers' />Happy Customers</h2>
              <Image src={GoogleRatingImg} className='img-fluid googleRatingImg mr-2' alt='google rating' onClick={()=>window.open("https://www.google.com/search?q=belgium+webnet+in+new+york&sca_esv=eb9a9a351395d50d&ei=-L0RaI3xHePn1e8P64XDuQI&oq=belgium+webnet+in+new&gs_lp=Egxnd3Mtd2l6LXNlcnAiFWJlbGdpdW0gd2VibmV0IGluIG5ldyoCCAIyBRAhGKABMgUQIRigATIFECEYoAEyBRAhGKABMgUQIRigAUj3MFDDBFiJJHABeAGQAQCYAY8CoAHNDKoBAzItN7gBAcgBAPgBAZgCCaAC6SDCAgoQABiwAxjWBBhHwgILEC4YgAQYxwEYrwHCAgUQABiABMICBhAAGBYYHsICCxAAGIAEGIYDGIoFwgIIEAAYgAQYogTCAhoQLhiABBjHARivARiXBRjcBBjeBBjgBNgBAcICBRAAGO8FmAMA4gMFEgExIECIBgGQBgi6BgYIARABGBSSBwkxLjAuNy44LTGgB64qsgcHMi03LjgtMbgH4iA&sclient=gws-wiz-serp#lrd=0x89c2590a50b3a235:0x8af09874060f51fc,1,,,,,,", "_blank")}  style={{cursor: 'pointer'}}/>
              <button onClick={() => history.push('/consultation')} className='shopify_btn_outline_black'>Book A Free Consultation</button>
            </div>
          </Col>
          <Col sm={12} md={8} lg={8}>
            <div className='bw_happy_customers_section_right'>
             

              <Slider {...settingsReview}>
                
              {
                  googleReviews.map((item, index) => (
                    <div className='bw_happy_customers_section_right_sliderr'>
                      <div className='bw_happy_customers_section_right_slider_innerr'>
                        <Image src={GoogleReviewImg} className='img-fluid googleReviewImg' alt='google Review og BW' onClick={()=>window.open("https://www.google.com/search?q=belgium+webnet+in+new+york&sca_esv=eb9a9a351395d50d&ei=-L0RaI3xHePn1e8P64XDuQI&oq=belgium+webnet+in+new&gs_lp=Egxnd3Mtd2l6LXNlcnAiFWJlbGdpdW0gd2VibmV0IGluIG5ldyoCCAIyBRAhGKABMgUQIRigATIFECEYoAEyBRAhGKABMgUQIRigAUj3MFDDBFiJJHABeAGQAQCYAY8CoAHNDKoBAzItN7gBAcgBAPgBAZgCCaAC6SDCAgoQABiwAxjWBBhHwgILEC4YgAQYxwEYrwHCAgUQABiABMICBhAAGBYYHsICCxAAGIAEGIYDGIoFwgIIEAAYgAQYogTCAhoQLhiABBjHARivARiXBRjcBBjeBBjgBNgBAcICBRAAGO8FmAMA4gMFEgExIECIBgGQBgi6BgYIARABGBSSBwkxLjAuNy44LTGgB64qsgcHMi03LjgtMbgH4iA&sclient=gws-wiz-serp#lrd=0x89c2590a50b3a235:0x8af09874060f51fc,1,,,,,,", "_blank")}  style={{cursor: 'pointer'}}/>
                        <p>{item.comment}</p>
                        <a className='text-decoration-underline' href='https://www.google.com/search?q=belgium+webnet+in+new+york&sca_esv=eb9a9a351395d50d&ei=-L0RaI3xHePn1e8P64XDuQI&oq=belgium+webnet+in+new&gs_lp=Egxnd3Mtd2l6LXNlcnAiFWJlbGdpdW0gd2VibmV0IGluIG5ldyoCCAIyBRAhGKABMgUQIRigATIFECEYoAEyBRAhGKABMgUQIRigAUj3MFDDBFiJJHABeAGQAQCYAY8CoAHNDKoBAzItN7gBAcgBAPgBAZgCCaAC6SDCAgoQABiwAxjWBBhHwgILEC4YgAQYxwEYrwHCAgUQABiABMICBhAAGBYYHsICCxAAGIAEGIYDGIoFwgIIEAAYgAQYogTCAhoQLhiABBjHARivARiXBRjcBBjeBBjgBNgBAcICBRAAGO8FmAMA4gMFEgExIECIBgGQBgi6BgYIARABGBSSBwkxLjAuNy44LTGgB64qsgcHMi03LjgtMbgH4iA&sclient=gws-wiz-serp#lrd=0x89c2590a50b3a235:0x8af09874060f51fc,1,,,,,,' target='_blank'>Read More</a>
                        <div className='d-flex align-items-end justify-content-between'>
                          <div className='d-flex align-items-center mt-2'>
                            <div class="avatar"> {item.name.charAt(0).toUpperCase()}</div>
                            <div className='avatar_right'>
                              <h4>{item.name}</h4>
                              <Rating name="size-small" value={item.reviews} size="small" defaultValue={5} readOnly />
                            </div>
                          </div>
                          <p className='time'>{item.time}</p>
                        </div>
                      </div>
                    </div>
                 ))
                }
              
              </Slider>
            </div>
          </Col>
        </Row>
      </Container>


    </div>
  )
}

export default HappyCustomers